import type { TFinancialAssistanceFieldArrayName } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/components/financialAssistance/types.ts';

export const FINANCIAL_ASSISTANCE_TABLE_MIN_WIDTH = 1200;
export const FINANCIAL_ASSISTANCE_DATE_COLUMN_INDEXES = [3, 4] as const;
export const FINANCIAL_ASSISTANCE_TABLE_COLUMN_WIDTHS = [
  '24%',
  '9%',
  '16%',
  '12%',
  '12%',
  '11%',
  '16%',
] as const;

export const getFinancialAssistanceTableHeaders = (issueOrReceiptDateLabel: string) => [
  'Найменування контрагента',
  'Валюта',
  'Заборгованість, тис. од.',
  issueOrReceiptDateLabel,
  'Дата погашення',
  'Рядок балансу',
  'Прострочення заборгованості, тис. од.',
];

export const FINANCIAL_ASSISTANCE_GROUPS: {
  name: TFinancialAssistanceFieldArrayName;
  title: string;
  issueOrReceiptDateLabel: string;
}[] = [
  {
    name: 'providedFinancialAssistance',
    title: 'Надані допомоги',
    issueOrReceiptDateLabel: 'Дата надання',
  },
  {
    name: 'receivedFinancialAssistance',
    title: 'Отримані допомоги',
    issueOrReceiptDateLabel: 'Дата отримання',
  },
];
